/**
 * 利用 Collapse 组件 结合 自定义一些样式
 * 创建时, 是用于图表设置中的 每个设置的折叠
 * 考虑到后期公共组件, 起名CardCollapse, 类似折叠一个卡片
 */
import React, { memo, ReactNode } from 'react';
import { Collapse, Icon, CollapseProps } from 'tea-component';
import classNames from "classnames";
import './index.scss';

export interface CardCollapseProps extends CollapseProps
{
  title: ReactNode; // 左上角标题
}

const CardCollapse = (props: CardCollapseProps) => {
  const { title, className, ...restProps } = props;
  
  return (
    <Collapse
      icon={active => <Icon type={active ? "arrowdown" : "arrowright"} />}
      iconPosition="right"
      className={classNames('dbl-card-collapse', className)}
      {...restProps}
    >
      <Collapse.Panel id="1" title={title} className={'dbl-card-collapse-panel'}>
        {props.children}
      </Collapse.Panel>
    </Collapse>
  );
};


export default memo(CardCollapse);